// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media print {\n[data-v-7676da14] .content-heading {\n    margin-bottom: 20px;\n    margin-left: 0px !important;\n    padding: 0px;\n}\n[data-v-7676da14] .non-printable {\n    display: none;\n}\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
